import { render } from "./MediaAndArchive.vue?vue&type=template&id=68b0f7f9"
import script from "./MediaAndArchive.vue?vue&type=script&lang=js"
export * from "./MediaAndArchive.vue?vue&type=script&lang=js"

import exportComponent from "/home/runcloud1user/webapps/ismail-khayat-vue/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.26_vue@3.5.26_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__